import React from 'react';
import { useTranslation } from 'react-i18next';

const getFeatureCards = (t: (key: string) => string) => [
  { img: 'feature_1.png', text: t('features-card-1') },
  { img: 'feature_2.png', text: t('features-card-2') },
  { img: 'feature_3.png', text: t('features-card-3') },
];

export const Features: React.FC = () => {
  const { t } = useTranslation();
  const featureCards = getFeatureCards(t);

  return (
    <section className="section-page">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="mx-auto max-w-[min(100%,52rem)] bg-clip-text text-balance text-xl font-bold leading-snug text-transparent md:text-2xl" style={{ background: 'linear-gradient(to bottom, #EDEDED, #D7D7D7)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            {t('features-title-line1')}
            <br />
            {t('features-title-line2')}
          </h2>
          <p className="mx-auto mt-4 max-w-3xl text-pretty text-base text-white/80">
            {t('features-note')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureCards.map((f, i) => (
            <div key={i} className="group rounded-2xl overflow-hidden border border-[#979797] bg-[#D7D7D7]/5 transition-[border-color,box-shadow] duration-300 ease-out hover:border-[#8A43FF]/50 hover:shadow-lg hover:shadow-[#8A43FF]/10">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={new URL(`../assets/figma/${f.img}`, import.meta.url).href} alt="" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]" />
              </div>
              <p className="p-4 text-pretty leading-relaxed text-white/90 sm:p-5 text-sm sm:text-base">{f.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
